import modalReservationForm from '../../components/MobileCalendarModal';
import axios from 'axios';

modalReservationForm(window, { http: axios });
